import { useState } from 'react';
import BasePrice from 'src/object/BasePrice';
import { post } from '../../commun/HTTP';
import Budget from '../../object/Budget';

export interface INbPersonnelProps {
    budget: Budget;
    basePrice: BasePrice;
}

export const NbPersonnelInput = (props: INbPersonnelProps) => {
    const { budget, basePrice } = props;

    const [val, setVal] = useState(budget.nb_personnel.get());

    return (
        <input
            disabled={budget.bon_commande.get() !== null || !basePrice.canAct()}
            type={'number'}
            value={val + ''}
            onBlur={() => {
                budget.leaveFocus();
            }}
            onFocus={() => {
                budget.getFocus();
            }}
            onChange={(e) => {
                let newVal = parseInt((e.target as any).value);
                budget.nb_personnel.set(newVal);
                budget.addEdit({
                    nb_personnel: budget.nb_personnel.get(),
                });
                setVal(newVal);
            }}
            placeholder="Quantité"
            className="bg-gray-300 w-32 placeholder:text-gray-600 border-gray-400 border rounded-lg py-2 px-3 focus:!border focus:!ring focus:!ring-blue-500 focus:!border-blue-500"
        />
    );
};
